import axiosConfig from "./axiosConfig";

interface DeleteHhDataTempResponse {
  success: boolean;
  message?: string;
}

const deleteHhDataTemp = async (
  authToken: string,
  fileGuid: string
): Promise<DeleteHhDataTempResponse> => {
  const { data } = await axiosConfig.delete(`/hh_data/temp/${fileGuid}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default deleteHhDataTemp;
